export const EVENT = {
  QUESTION_ANSWERED: 'Question Answered',
  REFER_FRIEND_INITIATED: 'Refer A Friend Initiated',
  PAYMENT_METHOD_SELECTED: 'Payment Method Selected',
  FEATURE_EXPOSED: 'Feature Exposed',

  SECTION_CHECKED: 'Section Checked',
  SECTION_UNCHECKED: 'Section Unchecked',
  SECTION_COMPLETED: 'Section Completed',
  PATH_DAY_VIEWED: 'Path Day Viewed',
  ALL_PATH_DAY_SECTIONS_CHECKED: 'All Path Day Sections Checked',
  PATH_DAY_COMPLETED: 'Path Day Completed',
  SURVEY_STARTED: 'Survey Started',
  SURVEY_FINISHED: 'Survey Finished',
  PATH_RECOMMENDATION_VIEWED: 'Path Recommendation Viewed',
  // DAY 0
  DAY_0_CONTINUE_TO_PATH: 'Day 0 Continue to My Path',
  DAY_0_CELEBRATION_CONTINUE_TO_PATH: 'Day 0 Celebration Continue to My Path',
  DUE_DATE_RECORDED: 'Due Date Recorded',
};

export const sanitizeObject = (obj: any): any => {
  if (obj === null || obj === undefined || obj === '') {
    return null;
  }

  if (typeof obj !== 'object') {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.length === 0 ? null : obj.map(sanitizeObject);
  }

  const sanitized: any = {};
  Object.keys(obj).forEach(key => {
    const value = sanitizeObject(obj[key]);
    if (value !== null) {
      sanitized[key] = value;
    }
  });

  return Object.keys(sanitized).length === 0 ? null : sanitized;
};
